import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Adm000Service } from '../../../../../core/_base/_service/adm000.service';
import { Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'kt-header-widget',
  templateUrl: './header-widget.component.html',
  styleUrls: ['./header-widget.component.scss']
})
export class HeaderWidgetComponent implements OnInit {
	
	ArrMainModule:any[]=[];
	lblCompanyCode: string;
	lblCompanyName: string;
	lblUserName: string;
	ArrModule:any[]=[];
	Count:number=0;
	lblExternalUserName: string;

  constructor(
	private objAdm000Service:Adm000Service,
	private changeDetectorRef: ChangeDetectorRef,
	private router: Router,
  ) { }

  ngOnInit() {
	this.objAdm000Service.GetModules().subscribe(dataAdm0000=>{

		var data = dataAdm0000.objADM0001;
		this.Count=data.Count;
		// this.lblCompanyCode = dataAdm0000.CompCod;
		// this.lblCompanyName = dataAdm0000.CompNam;
		// this.lblUserName = dataAdm0000.UserNam;
		if(localStorage.getItem('currentUser') != null)
		{
			var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
			// this.lblCompanyCode = userLoginDetails.CompCod;	
			// this.lblCompanyName = userLoginDetails.CompNam;
			// this.lblUserName = userLoginDetails.UserNam;

        	if(userLoginDetails.CompCod==null) {
                this.lblCompanyCode =''
            }
            else {
                this.lblCompanyCode = userLoginDetails.CompCod;
            }
 
            if(userLoginDetails.CompNam==null) {
                this.lblCompanyName ='VISAT GROUP OF INSTITUTIONS'
            } else {
                this.lblCompanyName = userLoginDetails.CompNam;
            }
            this.lblUserName = userLoginDetails.UserNam;
            this.lblExternalUserName = userLoginDetails.ExternalUserName;


		}
		
		
		
		 // this.widgetInnerHtml = data.widgetInnerHtml;
		//  this.ArrModule = data;
		// this.ArrMainModule =  data.filter(x=>x.IsModule==1);
		this.changeDetectorRef.detectChanges();
	})
	
  }

onLogoClick() {

		this.objAdm000Service.GetModules().subscribe(dataAdm0000=>{
		this.Count=dataAdm0000.Count;

		if(this.Count==0){
		this.router.navigate(['widget/widget-dashboard/3']);
		this.changeDetectorRef.detectChanges();
		
		}
		else{
		this.router.navigate(['widget/widget-dashboard/3']);
		this.changeDetectorRef.detectChanges();

		}
		this.changeDetectorRef.detectChanges();
	})
		this.changeDetectorRef.detectChanges();
}

GoToWidgetDashBoard(){
        this.router.navigate(['/widget/widget-dashboard/3']);
        this.changeDetectorRef.detectChanges();
    }
}


